//Example
//https://github.com/vuejs/vuex/tree/main/examples/composition/shopping-cart


import { login, refreshlogin, API_Reset } from '../../apiCalls/api.js';
  import router from "@/router";
  //import useEventsBus from '../../eventsBus/eventsBus.js';
  import { useToast } from "vue-toastification";
  import i18n from '../../locales/i18n'
    
  
import ReLoginToast from "../../components/ReLoginToast.vue";

  
const toast = useToast();


const state = () => ({
    username: "",
    password: "",
    token: "",
    refresh_token:"",
    type: "SignIn",
    counter: false,
    timerWarning:true,
    defaultCount: 3500,
    relogin:false
})

// getters
const getters = {
    getUsername(state){
        return state.username;
    },
    getPassword(state){
        return state.password;
    },
    getToken(state){
        return state.token;
    }

}

// actions
const actions = {

    async handleLoginSubmit({state, commit, dispatch}) {
        try {
            const response = await login(state.username, state.password);
            commit('clearPassword');
            //Set token in localstorage for easy access
            localStorage.setItem('token', response.data.access_token);
            localStorage.setItem('refreshToken', response.data.refresh_token);

            var tokenExpiryDate = new Date();
            tokenExpiryDate.setSeconds(tokenExpiryDate.getSeconds() + parseInt(response.data.expires_in)-10);
            
            commit('setDefaultCount', parseInt(response.data.expires_in)-10)
            //commit('setDefaultCount', 10)
            dispatch('resetCounter');

            var ticks = ((tokenExpiryDate.getTime() * 10000) + 621355968000000000);
            localStorage.setItem('tokenExpiryDateInTicks', ticks);
            //set token in state
            commit('setToken', response.data.access_token);
            commit('setRefreshToken', response.data.refresh_token);
            dispatch('sidebar/setLogin', "", { root: true }) //used to call other vuex stores with a namespace, empty string is parameters, not needed in this case.
            localStorage.setItem('username', state.username);
          }
          catch (e) {
            toast.warning(i18n.global.t("loginPage.loginFailed")+"\r\n\r\n" +e.message);
          }
          if (localStorage.getItem('token')) {
            dispatch('startCounter');
            router.push('/')
          }
          else {
            localStorage.clear('token')
          }
    },

    async reLogin({state, commit,dispatch}){
        try {
            const response = await refreshlogin(state.refresh_token);
            var tokenExpiryDate = new Date();
            tokenExpiryDate.setSeconds(tokenExpiryDate.getSeconds() + parseInt(response.data.expires_in)-10);

            commit('setDefaultCount', parseInt(response.data.expires_in)-10)
            //commit('setDefaultCount', 10)
            
            var ticks = ((tokenExpiryDate.getTime() * 10000) + 621355968000000000);
            localStorage.setItem('token', response.data.access_token);
            localStorage.setItem('tokenExpiryDateInTicks', ticks);

            commit('setToken', response.data.access_token);
            commit('setRefreshToken', response.data.refresh_token);
            dispatch('startCounter');
            
        }
        catch (e) {
            toast.warning(i18n.global.t("loginPage.loginFailed")+"\r\n\r\n" +e.message);
            router.push('/login')
        }
    },

    handleForgotPassword({state, commit}) {
        if(state.type == "SignIn"){
            commit('setType', 'ForgotPassword');
        }
        else{
            commit('setType', 'SignIn');
        }
    },

    resetPassword({state, commit}){
        var json = {}
        json["Email"] = state.username;
        try {
            API_Reset(json);
            toast.success(i18n.global.t("loginPage.resetPasswordSuccess"));
            commit('setType', 'SignIn');
        }
        catch(e){
            toast.warning(i18n.global.t("loginPage.resetPasswordFailed")+"\r\n\r\n" +e.message);
        }
    },

    startCounterOnRefresh({state, commit, dispatch}){
        commit('setRefreshToken', localStorage.getItem("refreshToken"));
        if(!state.counter){
            var currentDate = new Date();
            var currentTick = currentDate.getTime() * 10000 + 621355968000000000;
            var expiryTick = localStorage.getItem('tokenExpiryDateInTicks');
            var secondsBetweenNowAndExpiryDate = (expiryTick - currentTick)/10000/1000 - 5;
            commit('setCount', secondsBetweenNowAndExpiryDate);
            dispatch('startCounter');
        }
    },
    /* TIMER LOGIC */
    async startCounter({ state, commit, dispatch }) {
        commit('setCounter', true);
        while (state.count > 0 && state.counter) {
          await new Promise(resolve => setTimeout(resolve, 1000));
          if (state.counter)
            commit('setCount', state.count-1);
          
          //Toast relogin at 5 minutes remaining
          if(state.count < 300 && state.timerWarning){
            commit('setTimerWarning', false);

            const reloginComponent = {
                component: ReLoginToast,
                listeners: {
                    reloginClick: () => {
                        dispatch('resetCounter');
                        commit('reLogin', true);
                    }
                }
            }
            toast.info(reloginComponent,{ timeout: 0 });
          }
        }
        //reset counter
        if(state.counter){
            dispatch('resetCounter');

            //Handle logout
            localStorage.clear('token')
            dispatch('sidebar/setLogout', "", { root: true })
            commit('clearUserNameAndPassword');
            location.reload();
        }
        if(state.relogin){
            dispatch('reLogin');
            commit('reLogin', false);
        }
      },

    resetCounter({state, commit}) {
        commit('setCount', state.defaultCount);
        commit('setCounter', false);
        commit('setTimerWarning', true)
      },

      resetCounterAndReLogin({state, commit}) {
          commit('setCount', state.defaultCount);
          commit('setCounter', false);
          commit('setTimerWarning', true)
        }

}

// mutations
const mutations = {
    clearUserNameAndPassword(state){
        state.username = "";
        state.password = "";
    },
    setUsername(state, username){
        state.username = username
    },
    setPassword(state, password){
        state.password = password
    },
    clearPassword(state){
        state.password = "";
    },
    setToken(state, token){
        state.token = token
    },
    setRefreshToken(state, refresh_token){
        state.refresh_token = refresh_token
    },
    setType(state, type){
        state.type = type
    },
    setDefaultCount(state, value){
        state.defaultCount = value;
    },
    setCount(state, value){
        state.count = value;
    },
    setCounter(state, value){
        state.counter = value;
    },
    setTimerWarning(state, value){
        state.timerWarning = value;
    },
    reLogin(state, value){
        state.relogin = value;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }


  
  
